import useAccount from "./useAccount";
import type { Team } from "./useAccountTypes";

export function useTeam(teamID: string | undefined): Team | undefined {
  const { data } = useAccount();

  const team = data?.teams?.find(({ id }) => id === teamID);
  return team;
}
